import React, { useContext } from "react";
import { FileContext } from "./Dashboard";

import DispEffect from "./Biases/DispEffect";
import Overconfidence from "./Biases/Overconfidence";
import Progress from "./Biases/Progress";
import UpdateFiles from "./UpdateFiles";

export default function Report() {
  const { reportData } = useContext(FileContext);

  let dispEffectPerc = "N/A";
  let overconfidencePerc = "N/A";

  try {
    dispEffectPerc = parseFloat(reportData.disposition_effect).toFixed(2) * 100 + "%";
  } catch {}

  try {
    overconfidencePerc = parseFloat(reportData.overconfidence).toFixed(2) * 100 + "%";
  } catch {}

  //GSAP

  return (
    <>
      <section className="report-section">
        <div className="report-container">
          <h1 className="report-header">
            <span>Bias </span> <span>Report</span>
            <span className="report-header-add"> (OVERALL)</span>
          </h1>
          <div className="report-bias-container">
            <DispEffect dispEffectPerc={dispEffectPerc} />
            <Overconfidence overconfidencePerc={overconfidencePerc} />
          </div>
        </div>
      </section>
      <Progress />
      <UpdateFiles />
    </>
  );
}
